import { MDBAlert, MDBAutocomplete, MDBIcon, MDBInput, MDBTextArea } from 'mdb-react-ui-kit';
import GreetingAlertPopup from '../../apiclients/GreetingAlertPopup';
import React, { useEffect, useRef, useState } from 'react'
import Voice1 from "../../uimedia/lunavoices/Alloy_aka_Luna_tts-1-hd.mp3"
import Voice2 from "../../uimedia/lunavoices/Echo_aka_Eric_tts-1-hd.mp3"
import Voice3 from "../../uimedia/lunavoices/Ash_aka_Oscar_tts-1-hd.mp3"
import Voice4 from "../../uimedia/lunavoices/Shimmer_aka_Serena_tts-1-hd.mp3"
import { getGreetingWavFile } from '../../apiclients/streamsapi_bridge';
import { sanitizeAndLowercase } from '../../apiclients/CommonUtils';
import UIConstant from '../../apiclients/UIConstant';
import TTSGenerationPopup from '../../components/TTSGenerationPopup';

const TexttoSpeechgGreeting = ({ register, reset, setValue, watch, errors, wavFile, setwavFile, wavFilePath, setwavFilePath, setoldText, oldText, setIsloading, setwavFileName, setoldVoiceType, oldVoiceType, huntFlag, isActive, greetingObject, ttswaveFile, control, Controller, setIsStreamingAudio }) => {
    const [playVoiceId, setplayVoiceId] = useState("");
    const [interErrorMessage, setinterErrorMessage] = useState("");
    const voices = [
        { voiceid: 1, voiceurl: Voice1, title: "Luna" },
        { voiceid: 2, voiceurl: Voice2, title: "Eric" },
        { voiceid: 3, voiceurl: Voice3, title: "Oscar" },
        { voiceid: 4, voiceurl: Voice4, title: "Serena" }
    ];
    const textValue = watch("text") || "";
    const maxChars = huntFlag ? UIConstant.MAX_CHAR_MEDIA_HUNT : UIConstant.MAX_CHAR_MEDIA;
    const [displayLunaVoices, setdisplayLunaVoices] = useState(voices);
    const [voiceValue, setvoiceValue] = useState("Luna");
    const audioRef = useRef(null); // Ref to the audio element
    const [isPlaying, setIsPlaying] = useState(false); // To track if the audio is playing
    const [blobURL, setBlobURL] = useState(null);
    const [isAudioPlaying, setisAudioPlaying] = useState(false);
    const [showTTSGeneration, setShowTTSGeneration] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [showMaxLengthInfo, setShowMaxLengthInfo] = useState(false);

    useEffect(() => {
        if (greetingObject && greetingObject?.uploadType === 3 && ttswaveFile) {
            setvoiceValue(voices.find(v => v.voiceid === greetingObject.voice_type)?.title || "Luna");
            setwavFile(ttswaveFile);
            setoldVoiceType(greetingObject.voice_type);
            const normalizedMessage = sanitizeAndLowercase(greetingObject.text);
            setoldText(normalizedMessage);
            reset({
                name: greetingObject.title || greetingObject.display || "",
                filename: greetingObject.filename || "",
                voice_type: greetingObject.voice_type || 1,
                text: greetingObject.text || "",
            });
            if ((greetingObject.text || "").length > maxChars) {
                setShowMaxLengthInfo(true);
            }
        }

    }, [greetingObject, ttswaveFile])



    const handlePlayAudio = (e, audioUrl, voiceid) => {
        e.preventDefault();
        e.stopPropagation();
        setplayVoiceId(voiceid);
        if (audioRef.current) {
            audioRef.current.pause(); // Pause the audio
            audioRef.current.currentTime = 0; // Reset to the start
            setIsPlaying(false); // Update the state
        }

        // Set the new audio source and play it
        if (audioRef.current) {
            audioRef.current.src = audioUrl;
            audioRef.current.play();
            setIsPlaying(true); // Update the state to reflect audio is playing
        }
    };

    const handlePauseAudio = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
            setplayVoiceId("");
            setisAudioPlaying(false);
        }

    }

    function handleVoiceSelect(value) {
        setvoiceValue(value);
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
        }
        setplayVoiceId("");
        const voice = voices.find(v => v.title === value);

        if (voice) {
            setValue("voice_type", parseInt(voice.voiceid), { shouldDirty: true });
        }
    }


    const playMiscFile = (e, message) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (message && message.trim() !== "") {
            getAudioFileInfo(message);
        }
    };
    const getAudioFileInfo = async (message) => {
        try {
            // Cleanup previous audio URL
            if (blobURL) URL.revokeObjectURL(blobURL);
            setBlobURL(null);

            // Stop any currently playing audio
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                setisAudioPlaying(false);
            }

            const normalizedMessage = await sanitizeAndLowercase(message);
            let apiResponse = null;

            // 🔥 1. Use cached WAV file if message + voice_type didn't change
            if (
                wavFile &&
                normalizedMessage === oldText &&
                parseInt(watch("voice_type")) === parseInt(oldVoiceType)
            ) {
                const existingURL = URL.createObjectURL(wavFile);
                setBlobURL(existingURL);
                setisAudioPlaying(true); // autoPlay will handle playback
                return;
            }

            // 🔥 2. Show loader
            setIsGenerating(true);
            setShowTTSGeneration(true);

            apiResponse = await getAudioFile(message);

            setIsGenerating(false);
            setShowTTSGeneration(false);

            if (apiResponse?.status === 200) {
                // Streaming via MediaSource
                const mediaSource = new MediaSource();
                const streamURL = URL.createObjectURL(mediaSource);

                // Set blob URL - autoPlay will handle playback
                setBlobURL(streamURL);
                setisAudioPlaying(true);
                setIsStreamingAudio(true);

                mediaSource.addEventListener("sourceopen", async () => {
                    const mimeType = "audio/mpeg";
                    const sourceBuffer = mediaSource.addSourceBuffer(mimeType);
                    const reader = apiResponse.body.getReader();

                    let chunks = [];

                    const pump = async () => {
                        const { done, value } = await reader.read();

                        if (done) {
                            // Finish the stream
                            const finalize = () => {
                                if (mediaSource.readyState === "open") {
                                    try {
                                        mediaSource.endOfStream();
                                    } catch (e) {
                                        console.warn("endOfStream error:", e.message);
                                    }
                                }
                            };

                            if (sourceBuffer.updating) {
                                sourceBuffer.addEventListener("updateend", finalize, { once: true });
                            } else {
                                finalize();
                            }

                            // Build final audio blob for caching
                            const finalBlob = new Blob(chunks, { type: mimeType });
                            const finalURL = URL.createObjectURL(finalBlob);

                            // Store everything
                            setwavFile(finalBlob);
                            setwavFilePath(finalURL);

                            // Filename extraction
                            const cd = apiResponse.headers.get("Content-Disposition");
                            if (cd) {
                                const match = cd.match(/filename="?([^"]+)"?/);
                                if (match?.[1]) setwavFileName(match[1]);
                            }

                            // Cache inputs
                            setoldText(normalizedMessage);
                            setoldVoiceType(parseInt(watch("voice_type")));
                            setIsStreamingAudio(false);

                            return;
                        }

                        chunks.push(value);

                        // Wait for buffer to finish updating
                        await new Promise((resolve) => {
                            if (!sourceBuffer.updating) return resolve();
                            sourceBuffer.addEventListener("updateend", resolve, { once: true });
                        });

                        sourceBuffer.appendBuffer(value);
                        pump();
                    };

                    pump();
                });
            } else {
                // API Error handling
                const errJSON = await apiResponse.json().catch(() => ({}));
                setinterErrorMessage(errJSON?.message ?? "Internal Server Error");
                setIsStreamingAudio(false);
            }

            setIsGenerating(false);
            setShowTTSGeneration(false);
        } catch (error) {
            console.error("Unable to load audio file:", error);
            setIsGenerating(false);
            setShowTTSGeneration(false);
            setIsStreamingAudio(false);
        }
    };


    async function getAudioFile(message) {
        try {
            let reqBodyInfo = {
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                text: message,
                voice_type: parseInt(watch("voice_type")),
            };

            console.log(
                "request to play :::::::::::::: " + JSON.stringify(reqBodyInfo)
            );
            let apiResponse = await getGreetingWavFile(reqBodyInfo);
            return apiResponse;
        } catch (error) {
            console.log(`Unable to load the audio file : ${error}`);
        }
        return "";
    }

    useEffect(() => {
        if (!isActive) {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            setIsPlaying(false);
            setplayVoiceId("");
            setisAudioPlaying(false);
        }
    }, [isActive]);


    return (
        <>
            <div class="tel-numbers mt-2"><strong>Name:<span className='text-danger'>*</span></strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2 text-start'>
                    <MDBInput
                        placeholder="Name"
                        maxLength={60}
                        {...register("name", { required: "Name is required" })}
                    />
                    {errors.name && <p className="text-danger">{errors.name.message}</p>}
                    {greetingObject && Object.keys(greetingObject).length > 0 && greetingObject.uploadType === 3 && (
                        <p className='phrecording mt-1'>
                            Note: The Create New button remains disabled until a change is detected in the Name field.
                        </p>
                    )}
                </div>
            </div>
            {/* <div class="tel-numbers mt-2 text-start"><strong>File Name:<span className='text-danger'>*</span></strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2'>
                    <MDBInput
                        placeholder="File Name"
                        {...register("filename", { required: "File Name is required" ,
                            pattern :{
                                value:  /^[a-zA-Z0-9_-]*$/,
                                message: "Invalid File name. Only letters, numbers, underscores, hyphens are allowed."
                            }
                        })}
                        maxLength={30}
                    />
                    <p className='text-secondary text-start small'>Greeting file name can be alphanumeric and can include underscore(_) and hyphen(-)</p>
                    {errors.filename && <p className="text-danger">{errors.filename.message}</p>}
                </div>
            </div> */}
            <div class="tel-numbers mt-2 text-start"><strong>Voice:</strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2 position-relative'>
                    <MDBAutocomplete
                        data={displayLunaVoices}
                        placeholder='Select Voice'
                        displayValue={(row) => row.title}
                        value={voiceValue}
                        onSelect={(value) => handleVoiceSelect(value)}
                        itemContent={(result) => (
                            <div className='autocomplete-custom-item-content w-100'>
                                <div className='d-flex align-items-center w-100'>
                                    <div className='autocomplete-custom-item-title w-40'>{result.title}</div>
                                    <MDBIcon
                                        far
                                        icon={playVoiceId === result.voiceid ? "pause-circle" : "play-circle"}
                                        className='ms-2'
                                        size='lg'
                                        color='primary'
                                        onClick={(e) => {
                                            if (playVoiceId === result.voiceid) {
                                                handlePauseAudio(e);
                                            } else {
                                                handlePlayAudio(e, result.voiceurl, result.voiceid);
                                            }
                                        }
                                        }
                                    />
                                </div>
                            </div>
                        )}
                    />
                    <div className='position-absolute top-50 translate-middle' style={{ right: "15px" }}>
                        <MDBIcon fas icon='caret-down' color='secondary' />
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-between">
                <strong>Enter Your Message :</strong>
                <div className='cursor-pointer'
                    onClick={(e) => {
                        if (isAudioPlaying) {
                            handlePauseAudio(e);
                        } else {
                            playMiscFile(e, watch("text") || "");
                        }
                    }}
                >
                    <MDBIcon far icon={isAudioPlaying ? "pause-circle" : "play-circle"} color='primary' className='me-2' />
                    Preview
                </div>
            </div>
            <div className="d-flex align-items-center">
                <div className="w-100 my-2 text-start">
                    <Controller
                        name="text"
                        control={control}
                        rules={{
                            required: "Message is required",
                            maxLength: {
                                value: maxChars,
                                message: `Message cannot exceed ${maxChars} characters.`,
                            },
                        }}
                        render={({ field }) => (
                            <>
                                <MDBTextArea
                                    rows={5}
                                    style={{ minHeight: "75px" }}
                                    placeholder="Enter Your Message"
                                    value={watch("text")}
                                    onChange={(e) => {
                                        const sanitized = e.target.value
                                            .replace(/\n/g, ' ')
                                            .replace(/\s+/g, ' ')
                                            .slice(0, maxChars);
                                        setValue("text", sanitized, {
                                            shouldDirty: true,
                                            shouldValidate: true,
                                        });
                                    }}
                                />

                                <div className="d-flex align-items-center justify-content-between w-100">
                                    {errors.text && (
                                        <p className="text-danger w-50">{errors.text.message}</p>
                                    )}
                                    <small className="text-muted text-end d-inline-block w-100">
                                        {textValue.length}/{maxChars}
                                    </small>
                                </div>
                            </>
                        )}
                    />
                </div>
            </div>
            {interErrorMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setinterErrorMessage("")}
                >
                    {interErrorMessage}
                </MDBAlert>
            )}

            <TTSGenerationPopup
                isOpen={showTTSGeneration}
                onClose={() => setShowTTSGeneration(false)}
                onCancel={() => {
                    setIsGenerating(false);
                    setShowTTSGeneration(false);
                }}
                isGenerating={isGenerating}
            />
            <audio
                ref={audioRef}
                src={blobURL}
                hidden
                autoPlay
                onEnded={handlePauseAudio}
            />

            <GreetingAlertPopup
                isOpen={showMaxLengthInfo}
                popupheading="Disclaimer"
                message={`The message exceeds the provider’s maximum allowed length (${maxChars} characters). Modifying the message or voice may result in truncation to fit the limit. These changes will be reflected in all places where this media file is used.`}
                mode="ok"
                onOk={() => setShowMaxLengthInfo(false)}
            />
        </>
    )
}

export default TexttoSpeechgGreeting
